import { PaginatedListResult, usePaginatedList } from "@hooks/usePaginatedList";
import { ServicesURL, downloadFile } from "@utils/utilsApi";
import { RegistryHistoryRow } from "../types";

interface UseRegistryHistoryArgs {
  corporateId: string | number;
  editionId: string | number;
  page: number;
  pageSize: number;
  search?: string;
  sort?: string | null;
}

export interface UseRegistryHistoryResult extends PaginatedListResult<RegistryHistoryRow> {
  downloadHistory: () => Promise<unknown>;
}

export const useRegistryHistory = ({
  corporateId,
  editionId,
  page,
  pageSize,
  search,
  sort,
}: UseRegistryHistoryArgs): UseRegistryHistoryResult => {
  const url =
    corporateId && editionId
      ? `${ServicesURL.getVirtualRegisterHistory}?corporateId=${corporateId}&editionId=${editionId}`
      : null;

  const list = usePaginatedList<RegistryHistoryRow>(url, {
    page,
    pageSize,
    search,
    sort,
  });

  const downloadHistory = () =>
    downloadFile(
      `${ServicesURL.getVirtualRegisterHistoryFile}?corporateId=${corporateId}&editionId=${editionId}`,
      false,
      "",
      { responseType: "blob" },
    );

  return { ...list, downloadHistory };
};
